import { format } from 'date-fns';
import { useI18nLn } from '~/hooks/store';

export const formatJPDatetimePeriodByDate = (
  str_start_at: string,
  str_end_at: string
): string => {
  const start_at = new Date(str_start_at);
  const end_at = new Date(str_end_at);
  if (start_at.getFullYear == end_at.getFullYear) {
    return (
      formatJPDatetimeStrByDate(start_at) +
      ' ~ ' +
      format(end_at, "M月d日' 'HH時mm分")
    );
  } else {
    return (
      formatJPDatetimeStrByDate(start_at) +
      ' ~ ' +
      formatJPDatetimeStrByDate(end_at)
    );
  }
};

export const formatEventPeriod = (
  str_start_at: string,
  str_end_at: string,
  display_date?: boolean | null
): string => {
  const start_at = new Date(str_start_at);
  const end_at = new Date(str_end_at);
  const now_at = new Date();

  if (now_at < start_at) {
    const start_difference_minute =
      (start_at.getTime() - now_at.getTime()) / 1000 / 60;
    const start_difference_hour = start_difference_minute / 60;
    const start_difference_day = start_difference_hour / 24;
    let display_difference = `${Math.floor(start_difference_day)}日`;
    if (start_difference_day < 1) {
      display_difference = `${Math.floor(start_difference_hour)}時間`;
      if (start_difference_hour < 1) {
        display_difference = `${Math.floor(start_difference_minute)}分`;
      }
    }
    const formated_start_at = formatJPDatetimeStrByDate(start_at);
    return `開催まであと${display_difference}${
      (display_date ?? true) ? ` (${formated_start_at}開始予定)` : ''
    }`;
  }
  if (now_at > end_at) {
    return '開催終了しました';
  }

  const end_difference_minute =
    (end_at.getTime() - now_at.getTime()) / 1000 / 60;
  const end_difference_hour = end_difference_minute / 60;
  const end_difference_day = end_difference_hour / 24;
  let display_difference = `${Math.floor(end_difference_day)}日`;
  if (end_difference_day < 1) {
    display_difference = `${Math.floor(end_difference_hour)}時間`;
    if (end_difference_hour < 1) {
      display_difference = `${Math.floor(end_difference_minute)}分`;
    }
  }
  const formated_end_at = formatJPDatetimeStrByDate(end_at);
  return `あと${display_difference}${
    (display_date ?? true) ? ` (~${formated_end_at}まで)` : ''
  }`;
};

export const generateEventPeriodState = (
  str_start_at: string,
  str_end_at: string,
  display_date?: boolean | null
): {
  diff: number;
  unit: 'day' | 'hour' | 'minute';
  status: 'ended' | 'selling' | 'comingsoon';
  absolute_date?: string;
} => {
  const start_at = new Date(str_start_at);
  const end_at = new Date(str_end_at);
  const now_at = new Date();

  if (now_at < start_at) {
    const start_difference_minute =
      (start_at.getTime() - now_at.getTime()) / 1000 / 60;
    const start_difference_hour = start_difference_minute / 60;
    const start_difference_day = start_difference_hour / 24;
    const formated_start_at = formatJPDatetimeStrByDate(start_at);
    if (start_difference_day < 1) {
      if (start_difference_hour < 1) {
        return {
          diff: Math.floor(start_difference_minute),
          unit: 'minute',
          status: 'comingsoon',
          absolute_date: formated_start_at,
        };
      }
      return {
        diff: Math.floor(start_difference_hour),
        unit: 'hour',
        status: 'comingsoon',
        absolute_date: formated_start_at,
      };
    }
    return {
      diff: Math.floor(start_difference_day),
      unit: 'day',
      status: 'comingsoon',
      absolute_date: formated_start_at,
    };
  }

  if (now_at > end_at) {
    return {
      diff: 0,
      unit: 'day',
      status: 'ended',
    };
  }

  const end_difference_minute =
    (end_at.getTime() - now_at.getTime()) / 1000 / 60;
  const end_difference_hour = end_difference_minute / 60;
  const end_difference_day = end_difference_hour / 24;
  const formated_end_at = formatJPDatetimeStrByDate(end_at);

  if (end_difference_day < 1) {
    if (end_difference_hour < 1) {
      return {
        diff: Math.floor(end_difference_minute),
        unit: 'minute',
        status: 'selling',
        absolute_date: formated_end_at,
      };
    }
    return {
      diff: Math.floor(end_difference_hour),
      unit: 'hour',
      status: 'selling',
      absolute_date: formated_end_at,
    };
  }
  return {
    diff: Math.floor(end_difference_day),
    unit: 'day',
    status: 'selling',
    absolute_date: formated_end_at,
  };
};

export const settionStatus = (
  str_start_at: string,
  str_end_at: string
): number => {
  const start_at = new Date(str_start_at);
  const end_at = new Date(str_end_at);
  const now_at = new Date();
  if (now_at < start_at) return 1;
  if (now_at > end_at) return 2;
  return 0;
};

export const getDateTime = (str_date_at: string): number => {
  const start_at = new Date(str_date_at);
  return start_at.getTime();
};

export const formatJPDatetimeStrByDate = (date: Date): string => {
  const { i18nLn } = useI18nLn();
  if (i18nLn === 'ja') {
    return format(date, "yyyy年M月d日' 'HH時mm分");
  }
  return format(date, "yyyy/MM/dd' 'HH:mm");
};

export const formatJPDatetimeStrByServerDateStr = (str: string): string => {
  const date = new Date(str);
  return formatJPDatetimeStrByDate(date);
};
